module.exports = __webpack_public_path__ + "static/Impact-2-3b7bc9e81dfbd3c2d648b880e0358e7f.jpg";